module.exports = __webpack_public_path__ + "img/15.673c7f9f.svg";